import { useEffect, useState } from "react";
import { ChevronDown, Armchair } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useCart } from "@/context/CartContext";
import { pad2, tableLabel } from "@/lib/api";

const FLOORS = [1, 2];
const TABLES = Array.from({ length: 15 }, (_, i) => i + 1);

export const TablePicker = () => {
  const { seat, setSeat, pickerOpen, setPickerOpen } = useCart();
  const [floor, setFloor] = useState(seat?.floor || 1);

  useEffect(() => {
    if (pickerOpen && seat) setFloor(seat.floor);
  }, [pickerOpen, seat]);

  const choose = (table) => {
    setSeat({ floor, table });
    setPickerOpen(false);
  };

  return (
    <Popover open={pickerOpen} onOpenChange={setPickerOpen}>
      <PopoverTrigger asChild>
        <button
          className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border text-sm font-medium transition-colors ${seat ? "bg-paper border-ink/20 text-ink" : "bg-amber-50 border-amber-300 text-amber-900 animate-pulse"}`}
          data-testid="table-floor-selector-button"
        >
          <Armchair className="w-4 h-4" strokeWidth={1.8} />
          {seat ? tableLabel(seat.floor, seat.table) : "Pilih nomor meja"}
          <ChevronDown className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[320px] bg-paper border-sage-200 p-5" data-testid="table-picker-popover">
        <div className="font-serif text-lg font-semibold">Kamu duduk di mana?</div>
        <p className="text-xs text-muted2 mt-1">Lihat nomor di stiker meja agar staf tahu lokasi pengantaran.</p>
        <div className="grid grid-cols-2 gap-2 mt-4" data-testid="floor-select-dropdown">
          {FLOORS.map((f) => (
            <button key={f} onClick={() => setFloor(f)} data-testid={`floor-select-button-${f}`}
              className={`py-2 rounded-lg text-sm font-semibold border transition-colors ${floor === f ? "bg-forest text-paper border-forest" : "bg-cream border-sage-200 hover:border-forest"}`}>
              Lantai {f}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-5 gap-2 mt-4">
          {TABLES.map((t) => {
            const active = seat?.floor === floor && seat?.table === t;
            return (
              <button key={t} onClick={() => choose(t)} data-testid={`table-select-button-${t}`}
                className={`h-11 rounded-lg text-sm font-semibold border transition-[background-color,transform] hover:-translate-y-0.5 ${active ? "bg-forest text-paper border-forest" : "bg-white/60 border-sage-200 hover:bg-sage-100"}`}>
                {pad2(t)}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
